import { css } from "@linaria/core";

import { TRANSITION_DURATION_MS } from "./constants";
import { makeSelectors } from "../../css/maker.selectors";
import { units } from "../../css-tokens/units";
import { colors } from "../../design-tokens/colors";
import { typographies } from "../../design-tokens/typographies";

export const tooltip = css`
  z-index: 200000;

  max-width: min(calc(${units.vw(100)} - ${units.px(30)}), ${units.px(300)});
  width: max-content;

  box-shadow: 0 0 ${units.px(5)} rgb(0 0 0 / 0.1);

  display: flex;

  opacity: 0;

  &:not(.active) {
    user-select: none;
    pointer-events: none;
  }

  &-enter {
    opacity: 0;

    &-active {
      opacity: 1;
      transition: opacity ${TRANSITION_DURATION_MS}ms linear;
    }

    &-done {
      opacity: 1;
    }
  }

  &-exit {
    opacity: 1;

    &-active {
      opacity: 0;
      transition: opacity ${TRANSITION_DURATION_MS}ms linear;
    }

    &-done {
      opacity: 0;
    }
  }

  /**
   * tooltips never make sense when printing the current document, so simply
   * hide them away.
   */
  @media print {
    display: none;
  }
`;

export const arrow = css`
  position: absolute;
  z-index: 0;

  filter: drop-shadow(0 0 ${units.px(2)} rgb(0 0 0 / 0.03));

  display: block;

  .${tooltip}[data-placement^="top"] & {
    bottom: 0;

    border-left: ${units.px(9)} solid transparent;
    border-right: ${units.px(9)} solid transparent;
    border-top: ${units.px(10)} solid ${colors.gray.sim100()};

    transform: translateY(${units.px(6)});
  }

  .${tooltip}[data-placement^="bottom"] & {
    top: 0;

    border-left: ${units.px(9)} solid transparent;
    border-right: ${units.px(9)} solid transparent;
    border-bottom: ${units.px(10)} solid ${colors.gray.sim100()};

    transform: translateY(${units.px(-6)});
  }

  .${tooltip}[data-placement^="right"] & {
    left: 0;

    border-top: ${units.px(9)} solid transparent;
    border-bottom: ${units.px(9)} solid transparent;
    border-right: ${units.px(10)} solid ${colors.gray.sim100()};

    transform: translateX(${units.px(-6)});
  }

  .${tooltip}[data-placement^="left"] & {
    right: 0;

    border-top: ${units.px(9)} solid transparent;
    border-bottom: ${units.px(9)} solid transparent;
    border-left: ${units.px(10)} solid ${colors.gray.sim100()};

    transform: translateX(${units.px(6)});
  }
`;

export const label = css`
  position: relative;
  z-index: 1;

  padding: ${units.px(4)} ${units.px(12)};

  background-color: ${colors.gray.sim100()};
  border-radius: ${units.px(4)};

  display: block;
  text-align: center;

  font-family: ${typographies.detail()};
  color: #fff;
`;

export const shortcut = css`
  margin-left: 0.5em;
  display: inline-block;

  /**
   * auto-wrap shortcut in parantheses using pseudo layers
   */
  &::before {
    content: "(";
  }

  &::after {
    content: ")";
  }
`;

export const selectors = makeSelectors({
  label,
  arrow,
  shortcut,
});
